import Client from '../axios-client';

const resource = '/fundraising/fundraising';

export default {
    getAll() {
        return Client.get(`${resource}`);
    },
    getGrid(parameters) {
        return Client.post(`${resource}/grid` + parameters);
    },
    getItem(id) {
        return Client.get(`${resource}/${id}`);
    },
    publish(fundraisingId, payload) {
        return Client.put(`${resource}/${fundraisingId}/publish`, payload);
    },
    getFundraisingImage(fundraisingId, imageId) {
        return Client.get(`${resource}/${fundraisingId}/image/${imageId}`, { responseType: 'blob'});
    },
};
